;(function($){

    function ModalitiesClasses()
    {
        var _ = this

        $("select#countries_id").on("change", function(e){
            e.preventDefault(); 
            $("select#establishment").attr('disabled', true);
            $("select#teacher").attr('disabled', true);
        });

        $("select#states_id").on("change", function(e){
            e.preventDefault(); 
            $("select#establishment").attr('disabled', true);            
            if ($(this).val() !== "" && $("select#countries_id").val() !== "") {
                _.getEstablishment($(".search-modality form").serialize());
            }
        });

        $("select#cities_id").on("change", function(e){
            e.preventDefault(); 
            $("select#establishment").attr('disabled', true);
            $("select#teacher").attr('disabled', true);
            
            if ($(this).val() !== "" && $("select#countries_id").val() !== "") {
                _.getEstablishment($(".search-modality form").serialize());               
            }
        });

        $("select#establishment").on("change", function(e){
            e.preventDefault(); 
            $("select#teacher").attr('disabled', true);
            
            if ($(this).val() !== "") {
                _.getTeacher($(".search-modality form").serialize());               
            }
        });        
    }


    ModalitiesClasses.prototype.getEstablishment = function(arguments)
    {
        var html = '<option value="">Selecione</option>';

       $.get($("#app_url").val() + "/api/modalidade/" + $("#modalities_id").val() + "/estabelecimentos?" + arguments, function(data)
       {
            $.each(data, function(index, value) {               
               html +='<option value="'+ index +'">'+ value +'</option>';
            });

            $("select#establishment").html(html).attr('disabled', false);
       });
    }

    ModalitiesClasses.prototype.getTeacher = function(arguments)
    {
        var html = '<option value="">Selecione</option>';

       $.get($("#app_url").val() + "/api/modalidade/" + $("#modalities_id").val() + "/professores?" + arguments, function(data)
       {
            $.each(data, function(index, value) {               
               html +='<option value="'+ index +'">'+ value +'</option>';
            }); 
            
            $("select#teacher").html(html).attr('disabled', false);   
       });
    }

   	new ModalitiesClasses();

}(jQuery));